<template>
  <div class="" v-if="model">
    <div class="board">
      <div class="boardrd first">
        <span v-if="model.status === 'ANSWER'" class="nbicon bkblbg">{{$t('front.qnaStatus.answer')}}</span>
        <span v-if="model.status === 'WAIT'" class="nbicon bgrbg">{{$t('front.qnaStatus.wait')}}</span>
        <span class="nbicon bgrbg">{{$t('front.qnaTypeCategory.' + model.faqType)}}</span>
        <span class="ml10">{{model.title}}</span>
      </div>
      <div class="boardrd">
        <!--span class="medal medal1"><em class="level">1</em></span-->
        <span>{{model.memName}}</span><span>{{dateFormatForBoard(model.regDate)}}</span>
      </div>
      <div class="boardbox">
        <p>{{model.content}}</p>
        <p class="rdcon rdconbg mt20" v-if="replyContent">
          {{replyContent}}
        </p>
      </div>
    </div>

    <div class="applibtns">
      <a v-if="prevId" @click="onClickPrevNext('prev')">{{$t('front.board.prev')}}</a>
      <a @click="onClickList">{{$t('front.board.list')}}</a>
      <a v-if="nextId" @click="onClickPrevNext('next')">{{$t('front.board.next')}}</a>
    </div>

  </div>
</template>

<script>
import { getBoardCookie } from '@/libs/auth-helper'

export default {
  name: 'qnaread',
  components: {
  },
  data () {
    return {
      boardType: 'faq',
      boardIdx: null,
      model: null,
      replyContent: '',
      prevId: null,
      nextId: null
    }
  },
  created () {
    this.boardIdx = this.$route.params.boardIdx
    this.loadBoardDetail(this.boardIdx)

    this.idxList = getBoardCookie().split(',')
    console.log(this.idxList)

    if (this.idxList.length > 0) {
      for (let i = 0, iLen = this.idxList.length; i < iLen; i++) {
        if (this.idxList[i] === this.boardIdx.toString()) {
          if (this.idxList[i - 1]) {
            this.prevId = this.idxList[i - 1]
          }
          if (this.idxList[i + 1]) {
            this.nextId = this.idxList[i + 1]
          }
        }
      }
    }
  },
  methods: {
    async loadBoardDetail (boardIdx) {
      const params = {
        boardIdx: boardIdx,
        boardType: this.boardType
      }
      this.model = await this.getBoardDetail(params)
      this.replyContent = this.model.comment.length > 0 ? this.model.comment[0].content : ''
    },
    onClickPrevNext (type) {
      let id = this.prevId
      if (type === 'next') {
        id = this.nextId
      }
      this.$router.push({ name: 'qnaread', params: { boardIdx: id } })
    },
    onClickList () {
      this.$router.push({ name: 'qna' })
    }
  }
}
</script>
<style src="@/styles/striNew.css"></style>

<style scoped>
/* 1:1 문의 상세 - 화이트 카드형 보정
   template/script 구조는 유지하고 상세 화면 쉐입만 정리 */

.board {
  width: 100% !important;
  margin: 24px 0 0 !important;
  padding: 0 !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.boardrd {
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  padding: 0 20px !important;
  border-bottom: 1px solid #dfe6ef !important;
  background: #ffffff !important;
  color: #263244 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  box-sizing: border-box !important;
}

.boardrd.first {
  min-height: 58px !important;
  border-top: 3px solid #2f6df6 !important;
  background: #f8fafc !important;
  color: #111827 !important;
  font-size: 15px !important;
  font-weight: 800 !important;
}

.boardrd:not(.first) {
  justify-content: flex-start !important;
  color: #475569 !important;
}

.boardrd:not(.first) span + span {
  position: relative !important;
  margin-left: 12px !important;
  padding-left: 12px !important;
}

.boardrd:not(.first) span + span::before {
  content: '' !important;
  position: absolute !important;
  left: 0 !important;
  top: 50% !important;
  width: 1px !important;
  height: 12px !important;
  background: #cbd5e1 !important;
  transform: translateY(-50%) !important;
}

.boardrd .ml10 {
  margin-left: 4px !important;
  color: #111827 !important;
  font-weight: 800 !important;
}

.nbicon {
  min-width: 58px !important;
  height: 24px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 10px !important;
  border-radius: 999px !important;
  border: 1px solid #d4ddeb !important;
  background: #eef2f7 !important;
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 24px !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
}

.bkblbg {
  border-color: #93c5fd !important;
  background: #dbeafe !important;
  color: #1d4ed8 !important;
}

.bgrbg {
  border-color: #cbd5e1 !important;
  background: #f1f5f9 !important;
  color: #334155 !important;
}

.boardbox {
  min-height: 150px !important;
  padding: 22px 20px 26px !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  box-sizing: border-box !important;
}

.boardbox p {
  margin: 0 !important;
  padding: 0 !important;
  color: #1f2937 !important;
  font-size: 14px !important;
  line-height: 1.75 !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
}

.boardbox .rdcon {
  margin-top: 22px !important;
  padding: 18px 18px !important;
  border: 1px solid #e4eaf3 !important;
  border-radius: 10px !important;
  background: #f8fafc !important;
  color: #334155 !important;
}

.boardbox .rdcon::before {
  content: '답변' !important;
  display: block !important;
  margin-bottom: 10px !important;
  color: #2563eb !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.applibtns {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  margin: 32px 0 0 !important;
  padding: 0 !important;
}

.applibtns a {
  min-width: 138px !important;
  height: 34px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border: 1px solid #5969d7 !important;
  border-radius: 6px !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 34px !important;
  text-decoration: none !important;
  cursor: pointer !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.16) !important;
  box-sizing: border-box !important;
}

.applibtns a:hover {
  background: #4656c6 !important;
  border-color: #4656c6 !important;
}

@media (max-width: 1000px) {
  .board {
    margin-top: 16px !important;
    border-radius: 10px !important;
  }

  .boardrd {
    min-height: auto !important;
    flex-wrap: wrap !important;
    padding: 13px 14px !important;
  }

  .boardrd.first {
    min-height: auto !important;
  }

  .boardbox {
    min-height: 120px !important;
    padding: 18px 14px 22px !important;
  }

  .applibtns {
    margin-top: 22px !important;
  }

  .applibtns a {
    min-width: 110px !important;
  }
}
</style>
<style src="@/styles/mobile.css"></style>
